import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addbranch',
  templateUrl: './addbranch.component.html',
  styleUrls: ['./addbranch.component.css']
})
export class AddbranchComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  branchColl: any = [];
  branchid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  branchform = new FormGroup({
    branchid: new FormControl(0),
    branchname: new FormControl('', Validators.required),
    branchcode: new FormControl('', Validators.required),
    address: new FormControl(''),
    country: new FormControl(''),
    phone: new FormControl(''),
    email: new FormControl(''),
    website: new FormControl(''),
    taxregnum: new FormControl(''),
    state: new FormControl(''),
    logourl: new FormControl(''),
    logoimage: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Branch";

  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  @Input() branchname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, private productFindService: NgbModal,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.branchid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {

    this.loginService.fnSetFirstControlFocus('branchname');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.branchform.reset();
      this.fnInitializebranch();

      if (this.branchid > 0) {
        this.fngetBranch();
      }
      this.fngetCountries();
      this.fngetState();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.branchid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializebranch() {
    this.branchform.setValue({

      branchid: 0,
      branchname: '',
      branchcode: '',
      address: '',
      country: '',
      phone: '',
      email: '',
      website: '',
      taxregnum: '',
      state: '',
      logourl: '',
      logoimage: null,
      inactive: false,
    })
  }
  fngetCountries() {

    this.appService.getCountries().subscribe((res) => {
      this.countryColl = res.json();

    })
  }

  fngetState() {

    var country = this.branchform.get('country').value

    this.stateColl = []

    this.appService.getState(country).subscribe((res) => {
      this.stateColl = res.json();
      //console.log(this.stateColl)

    })
  }
  //Get 
  fngetBranch() {
    var data = {
      'branchid': this.branchid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBranch(data)
      .subscribe(
        (res) => {
          this.branchColl = res.json().result;
          var editdata = this.branchColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.branchform.valid) {
        this.saveloading = true
        //Check
        var data = {
          'branchid': this.branchid,
          'branchname': this.branchform.get('branchname').value,
          'branchcode': this.branchform.get('branchcode').value,
          'address': this.branchform.get('address').value,
          'country': this.branchform.get('country').value,
          'state': this.branchform.get('state').value,
          'phone': this.branchform.get('phone').value,
          'email': this.branchform.get('email').value,
          'website': this.branchform.get('website').value,
          'taxregnum': this.branchform.get('taxregnum').value,
          'logoimage': this.strImage,
          'logourl': this.picurl,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.branchform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
        this.appService.fnCheckBranch(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.branchform.get('branchid').value > 0) {
                //Update Department
                this.fnSetBranch(data);
              }
              else {
                //Insert Department
                this.fnInsertBranch(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.branchform.controls['branchname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = true;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = true;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertBranch(data) {

    this.appService.fnInsertBranch(data).subscribe(
      (res) => {
        if (res.json().result != "") {
          this.saveloading = true;

          this.toastr.success('', "The new Branch has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.branchid);

          this.emitData.emit(this.branchid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = true;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetBranch(data) {

    this.appService.fnSetBranch(data).subscribe(
      (res) => {
        this.saveloading = true;

        if (res.json().result != "") {

          this.toastr.success('', "The Branch has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.branchid, data.branchname);

          this.emitData.emit(this.branchid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = true;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.branchform.setValue({

      branchid: deptBO.branchid,
      branchname: deptBO.branchname,
      branchcode: deptBO.branchcode,
      address: deptBO.address,
      country: deptBO.country,
      state: deptBO.state,
      phone: deptBO.phone,
      email: deptBO.email,
      website: deptBO.website,
      taxregnum: deptBO.taxregnum,
      logourl: deptBO.logourl,
      logoimage: null,
      inactive: deptBO.inactive,
    });

    this.fngetState();
    this.fngetCountries();
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  //Image Import
  changeListener($event): void {
    try {
      this.readThis($event.target);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  readThis(inputValue: any): void {

    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
      this.strImage = this.image.split(',')[1];
    }
    myReader.readAsDataURL(file);
  }

  removeimage() {
    this.image = null;
    this.strImage = null;
    this.picurl = "";
  }

  fnOpenFileBrowser(event: any) {

    event.preventDefault();

    let element: HTMLElement = document.getElementById('image') as HTMLElement;
    element.click();

  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }
      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
